module.exports = __webpack_public_path__ + "static/media/large-K-icon.a3f76ccc.png";